<script>
    /*____________ Config  ____________*/
    import { tour } from '../tour'
    tour.setupColors();
    console.log(tour.colors)
    
    /*____________ Imports ____________*/
    import { fade, fly } from 'svelte/transition';
    import { getContext } from 'svelte';
    const { open } = getContext('simple-modal');
    
    /* ____________ Mobile Detection ____________ */
    import UA from 'ua-parser-js';
    const ua = new UA();
    let isMobile = ua.getResult().device['type'] == 'mobile';
    
    /*____________ Components ____________*/
    import Krpano from './Krpano.svelte'
    import Mapbox from './Mapbox.svelte'
    import SwitchViews from "./SwitchViews.svelte";
    import MapButton from './MapButton.svelte';
    import InfoSidebar from './InfoSidebar.svelte'
    import Logo from "./Logo.svelte";
    import HamburgerMenu from "./HamburgerMenu.svelte";
    import NextScene from "./NextScene.svelte";
    import PrevScene from "./PrevScene.svelte";
    import WatermarkLogo from "./WatermarkLogo.svelte";
    import ThumbsGrid from "./ThumbsGrid.svelte";
    import Video from './Video.svelte';
    import Audio from './Audio.svelte';
    import Popup from './Popup.svelte';
    import SceneButton from './SceneButton.svelte';
    import PopupGallery from './PopupGallery.svelte';
    
    /*____________ Variables ____________*/
    let visibleUi = false;
    let video;
    let tourLogo = isMobile ? tour.logo.mobile : tour.logo;
    let editor = false;

    // audio
    let sceneAudioPlaying;
    
    // Map variables
    let expandedMap = false;
    let expandedTour = true;
    let zoom;

    // Make scene button slightly smaller than logo
    let sceneButtonWidth = tourLogo.width * 0.8;

    // center scene button on logo
    let sceneButtonX = (tourLogo.width / 2) - (sceneButtonWidth / 2) + 20;
    
    // position scene button under logo
    let sceneButtonY = tourLogo.height + 25;

	let sceneButtonSettings = tour.sceneButton;
  if (isMobile) { sceneButtonSettings = tour.sceneButton.mobile;}
  if(sceneButtonSettings){
      if(sceneButtonSettings.position){
          sceneButtonX = sceneButtonSettings.position.x;
          sceneButtonY = sceneButtonSettings.position.y;
      }

      if(sceneButtonSettings.width){
          sceneButtonWidth = sceneButtonSettings.width;
      }
  }

    /*____________ Functions ____________*/
    function showUi(){ visibleUi = true; }
    
    // setup map
    if(typeof tour.map === 'object'){ setMapZoom(); }

    function getHotspotContent(hotspot){
        if(typeof hotspot === 'string'){ hotspot = tour.currentScene.getHotspot(hotspot); }
        
        let gallery = null;
        if(hotspot.popup_gallery){ gallery = tour.currentScene.getGallery(hotspot.popup_gallery); }

        return {
            name: hotspot.name,
            title: tour.parseContent(hotspot.hotspot_title),
            image: hotspot.popup_image,
            content: tour.parseContent(hotspot.popup_text),
            videoUrl: hotspot.popup_video_embed,
            gallery: gallery,
            handleVideoLoad: function(){
                video = hotspot.popup_video_embed;
                sceneAudioPlaying = false;
                // loadVideo(hotspot.popup_video_embed);
            },
        };
    }
    
    function openHotspotInfo(popupContent){
        // if hotspotName was passed instead of {object}
        //      create {popupContent} object from hotspot attributes
        if(typeof popupContent === 'string'){
            let hotspotName = popupContent;
            popupContent = getHotspotContent(hotspotName);
        }
    
        new Popup({ 
          target: document.getElementById('popup-container'), 
          props: { ...popupContent },
        })
    }

    function openGalleryInfo(hotspot){
        if(typeof hotspot === 'string'){
            hotspot = tour.getHotspot(hotspot);
        }

        let gallery = tour.currentScene.getGallery(hotspot.popup_gallery);

        let popupContent = {
            name: hotspot.name,
            title: tour.parseContent(hotspot.hotspot_title),
            gallery: gallery,
        }

        new PopupGallery({ 
            target: document.getElementById('popup-container'), 
            props: {...popupContent}
        })
    }
    
    
    /*____________ Krpano Events ____________*/
    addEventListener('krpano:littleplanetend', (e)=>{  
        console.log(e);
        showUi();
    });
    
    // DISABLE IF InfoSidebar is being used
    if(!tour.infoSidebar){
        addEventListener('krpano:infoclick', (e)=>{
            console.log(e);
            let hotspotName = e.detail.hotspot;
            openHotspotInfo(hotspotName);
        });
    }

    addEventListener('krpano:galleryclick', (e)=>{
        console.log(e);
        let hs = tour.currentScene.getHotspot(e.detail.hotspot);
        openGalleryInfo(hs);
    });
    
    // Open Videos
    function loadVideo(v){
        video = v;
        sceneAudioPlaying = false;
    }

    function closeVideo(){
        sceneAudioPlaying = true;
    }

    function handleVideoLoadEvent(e){
        loadVideo(e.detail.video);
    }

    addEventListener('krpano:videoclick', (e)=>{
        console.log(e);
        handleVideoLoadEvent(e);
    });
    
    // Scene logos
    if(tour.sceneLogos){
        addEventListener('krpano:newpano', (e)=>{
            let sceneLogo = tour.currentScene.getLogo();
            tourLogo.src = sceneLogo ? sceneLogo : tour.logo.src;
        });
    }
    </script>
    
    <!-- /*____________ Markup ____________*/ -->
    <div id="popup-container"></div>
    {#if visibleUi}
        
        <!-- Editor -->
        {#if editor}
        <div class="editor">
        <button on:click={tour.editor.addHotspot}>Add Hotspot</button>
        <button on:click={tour.editor.startMoveMode}>Move Hotspots</button>
        <button on:click={()=>{
            console.log(tour.currentScene.getView())
            console.log(tour.currentScene.getPosition())
        }}>Log Info</button>
        </div>
        {/if}


        {#if tour.infoSidebar === true}
            <InfoSidebar on:loadvideo={handleVideoLoadEvent} logo={tourLogo}/>
        {/if}
        <!-- has map -->
        {#if typeof tour.map === 'object'}
        <MapButton click={tour.switchView} expandedMap={expandedMap}/>
        {/if}
    
        <Video bind:src={video} onClose={closeVideo} />
        
        {#if editor === false}
            {#if typeof tour.audio === 'object'}
                <Audio loop={tour.audio.loop} resumable={tour.audio.resumable} playing={sceneAudioPlaying} />
            {:else if tour.audio === true}
                <Audio playing={sceneAudioPlaying} />
            {/if}
        {/if}
        
        <HamburgerMenu 
            websiteUrl={tour.websiteUrl}
            requestInfoUrl={tour.requestInfoUrl}
        />
        
        <!-- no sidebar -->
        {#if tour.infoSidebar === false}
        <Logo 
            image={expandedMap ? tour.mapLogo.url : tourLogo.src} 
            width={expandedMap ? tour.mapLogo.width : tourLogo.width} 
            opacity="0.85"
        />

        <SceneButton text="Overview" x={sceneButtonX} y={sceneButtonY} width={sceneButtonWidth} opacity={0.8} />
        {/if}
        
        {#if tour.watermark === true}
        <WatermarkLogo/>
        {/if}
    
        {#if expandedTour}
            {#if !isMobile}
                <NextScene />
                <PrevScene />
            {/if}

            <ThumbsGrid 
                showPrevNext={false} 
                thumbsButtonOpen={"Open Locations"} 
                thumbsButtonClose={"Close Locations"}
            />
        {/if}
    {/if}
    
    {#if !tour.map}
    <Krpano expanded={expandedTour} xml='tour.xml' logo={tour.loadingLogo.src} logoWidth={tour.loadingLogo.width}/>
    {/if}
    
    {#if typeof tour.map === 'object'}
        <div class="{expandedTour ? 'large-view' : 'small-view'}" >
            <div class="hide-large" on:click={tour.switchView}>
                <div class="switch-hover">Show Map</div>
                <SwitchViews/>
            </div>
            <Krpano expanded={expandedTour} xml='tour.xml' />
        </div>
    
        {#if visibleUi}
        <div class="{expandedMap ? 'large-view' : 'small-view'}"  transition:fly={{y: 300, duration: 500 }}>
            <div class="hide-large" on:click={tour.switchView}>
                <div class="switch-hover">Show Tour</div>
                <SwitchViews/>
            </div>
            <Mapbox expanded={expandedMap} zoom={zoom}/>
        </div>
        {/if}
    {/if}
    
    
    <!-- /*____________ CSS ____________*/ -->
    <style>
    :global(.clicktext){
        font-weight: 900;
        font-size: 14px;
        text-decoration: underline;
    }
    
    .switch-hover {
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8);
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.5rem;
        font-family: 'Raleway', sans-serif;
        display: none;
        cursor:pointer;
    
        -webkit-user-select: none;  
        -moz-user-select: none;    
        -ms-user-select: none;      
        user-select: none;
    }
    
    .small-view:hover .switch-hover {
        display: flex;
    }
    
    .small-view {
        display: block;
        width: 300px;
        height: 200px;
    
        position:  absolute;
        bottom:  0;
        left:  0;
        z-index:  800;
    
        margin: 20px;
    
        border:  3px solid white;
        border-radius: 10px;
        box-shadow: -3px 3px 10px #000;
        background:  white;
    }
    
    .large-view {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    
        z-index:  700;
    }
    
    .large-view .hide-large { display: none;
    }
    
    :global(.large-view .mapboxgl-map) {
        height: 100vh;
        width: 100vw;
    }
    
    
    :global(.small-view .mapboxgl-map) {
        height: 200px;
        width: 300px;
    }
    
    @media only screen and (max-width: 600px) {
        .small-view {
            display: none;
        }
    }

    .editor {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0,0,0,0.8);
    }
    
    </style>
    